import React from "react";
import ProductCard from "./ProductCard";

// Helper function to safely capitalize strings
const safeCapitalize = (str) => {
  if (!str || typeof str !== 'string') return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const ProductsPage = ({ 
  filteredProducts, 
  selectedCategory, 
  selectedSubcategory, 
  sortBy, 
  onSortChange, 
  onFilterOpen, 
  onProductClick 
}) => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-900">
          {selectedCategory ? 
            selectedCategory === "materials" ? 
              selectedSubcategory ? `${safeCapitalize(selectedSubcategory)} Products` : 'All Materials' :
              `${safeCapitalize(selectedCategory)} ${selectedSubcategory ? `- ${safeCapitalize(selectedSubcategory)}` : ''}` : 
            'All Products'
          } ({filteredProducts && Array.isArray(filteredProducts) ? filteredProducts.length : 0} items)
        </h2>
        <div className="flex items-center space-x-4">
          <select 
            className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-pink-500 focus:border-transparent"
            value={sortBy}
            onChange={(e) => onSortChange(e.target.value)}
          >
            <option value="default">Sort by</option>
            <option value="price-low-high">Price: Low to High</option>
            <option value="price-high-low">Price: High to Low</option>
            <option value="newest">Newest</option>
            <option value="popular">Popular</option>
          </select>
          <button 
            className="border border-gray-300 rounded-lg px-4 py-2 hover:bg-gray-50 focus:ring-2 focus:ring-pink-500 focus:border-transparent"
            onClick={onFilterOpen}
          >
            Filter
          </button>
        </div>
      </div>
      
      {!filteredProducts || !Array.isArray(filteredProducts) || filteredProducts.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-gray-600">No products found in this category.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {filteredProducts.map(product => (
            <ProductCard key={product._id || product.id} product={product} onProductClick={onProductClick} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductsPage;
